/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "../../index";
import { authToken, authUserID, axiosInstance } from "../../axiosConfig";

const getBatchList =  async (page :number, size :number, keyword:any, plateStatus:any, batchStatus?:any, sort?:any , order?:any,batchNumber?:any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/batches/list_basic?page=${page}&size=${size}&sort=${sort}&order=${order}&plate_status=${plateStatus}&batch_status=${batchStatus}&batch_number=${batchNumber}&keyword=${keyword}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getBatchDetails =  async (page :number, size :number, sort:any , order:any , keyword:any, plateStatus:any, fromdate?:string , todate?:string , batchNumber?:any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/batches/list?page=${page}&size=${size}&sort=${sort}&order=${order}&plate_status=&batch_status=${plateStatus}&batch_number=${batchNumber || ""}&keyword=${keyword}&from_date=${fromdate}&to_date=${todate}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

const listPlateDetails =async (page :number, size :number, sort:any , order:any , plateStatus:any, batchId: any, keyword: any) => {
    try {
        const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_details?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active&plate_status=${plateStatus}&keyword=${keyword}&batch_number=${batchId}&serial_number=&location=`,
        {
          headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
          }
        });
        return response.data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          return error.response?.data
        }
      }
}

const listLotPlateDetails = async (page :number, size :number, sort:any , order:any , plateStatus:any, batchId: any, keyword: any, lot_id :any) => {
  try {
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_details?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active&keyword=${keyword}&batch_number=&serial_number=&current_location_id=&location=&incubator_id&lot_id=${lot_id}&lot_code`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
}

const getTestTubeBatchDetails =  async (page :number, size :number, sort:any , order:any, keyword :any, fromDate?:any, toDate? :any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/test_tubes/list_test_tube_batch?page=${page}&size=${size}&order=${order}&sort=${sort}&batch_id=${keyword}&from_date=${fromDate || ""}&to_date=${toDate || ""}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getSwabStickBatchDetails =  async (page :number, size :number, sort:any , order:any, keyword :any, fromDate?:any, toDate? :any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/swabs/list_swab_batch?page=${page}&size=${size}&order=${order}&sort=${sort}&batch_id=${keyword}&from_date=${fromDate || ""}&to_date=${toDate || ""}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getInnerTestTubeDetails =  async (page :number, size :number, sort:any , order:any, batch_no:any, keyword:any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/test_tubes/list_test_tube_details?page=${page}&size=${size}&order=${order}&sort=${sort}&batch_id=${batch_no}&serial_number=${keyword}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getInnerSwabStickDetails =  async (page :number, size :number, sort:any , order:any, batch_no:any, keyword:any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/swabs/list_swab_details?page=${page}&size=${size}&order=${order}&sort=${sort}&batch_id=${batch_no}&serial_number=${keyword}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const discardPlates = async (dataToSend: any) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/plates/discard_plate`, dataToSend,
        {
          headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
          }
        });
        return response.data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          return error.response?.data
        }
      }
}

const startAutoClave = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/plates/start_plate_auto_clave`, dataToSend,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const stopAutoClave = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/plates/stop_plate_auto_clave`, dataToSend,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getTestTubeBatchFilter =  async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/test_tubes/list_test_tube_batch?&order=desc&sort=id`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getAvailableTestTubeBatchFilter =  async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/saline_tubes/list_available_saline_tube_batch?&order=desc&sort=id`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getAvailableSwabStickBatchFilter =  async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/swabs/list_available_swab_stick_batch?&order=desc&sort=id`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getSwabStickBatchFilter =  async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/swabs/list_swab_batch?&order=desc&sort=id`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const TestTubeDropDown =  async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/test_tubes/list_test_tube_details?order=asc&sort=desc`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const SwabStickDropDown =  async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/swabs/list_swab_details?order=asc&sort=desc`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const discardBatchView =async (sort:any , order:any , plateStatus:any, batchId: any, keyword: any) => {
  try {
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_details?sort=${sort}&order=${order}&status=active&plate_status=${plateStatus}&keyword=${keyword}&batch_number=${batchId}&serial_number=&location=`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
}

const saveTemporaryManagement = async (dataToSend : any) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/batches/update_tcm_status`, 
     dataToSend,
     {
       headers: {
         'x-auth-token': authToken,
         'x-userid': authUserID
       }
     }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}


const getBatchDetailsTCM =  async (page :number, size :number, sort:any , order:any , keyword:any, plateStatus:any, fromdate?:string , todate?:string , batchNumber?:any, tcm_status?:any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/batches/list_basic?page=${page}&size=${size}&sort=${sort}&order=${order}&plate_status=&batch_status=${plateStatus}&batch_number=${batchNumber}&keyword=${keyword}&from_date=${fromdate}&to_date=${todate}&tcm_status=${tcm_status}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

  const BatchService = {
    getBatchList,
    listPlateDetails,
    discardPlates,
    startAutoClave,
    stopAutoClave,
    getBatchDetails,
    getTestTubeBatchDetails,
    getInnerTestTubeDetails,
    listLotPlateDetails,
    getTestTubeBatchFilter,
    TestTubeDropDown,
    discardBatchView,
    getSwabStickBatchDetails,
    getInnerSwabStickDetails,
    SwabStickDropDown,
    getSwabStickBatchFilter,
    saveTemporaryManagement,
    getBatchDetailsTCM,
    getAvailableTestTubeBatchFilter,
    getAvailableSwabStickBatchFilter
  };

  export { BatchService };